export const LANGUAGES = [
    {
        label: 'ENGLISH',
        code: 'en',
        language: 'English'
    },
    {
        label: 'HUNGARIAN',
        code: 'hu',
        language: 'Hungarian'
    },
    {
        label: 'RUSSIAN',
        code: 'ru',
        language: 'Russian'
    },
    {
        label: 'VIETNAMESE',
        code: 'vi',
        language: 'Vietnamese'
    },
    {
        label: 'POLISH',
        code: 'po',
        language: 'POLISH'
    },
    {
        label: 'GERMAN',
        code: 'ge',
        language: 'GERMAN'
    },
    {
        label: 'SPANISH',
        code: 'sp',
        language: 'SPANISH'
    }
];
